import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'lib/httpClient';
import { ApiResponse } from 'further-types/api';
import { useNotification } from 'hooks/ui/useNotification';
import useApiExceptionHandler from 'hooks/ui/useApiExceptionHandler';
import { Api } from 'further-types/investment-cool-off';
import trpcApi from 'lib/trpcClient';

function useSkipInvestmentCoolOff() {
  const utils = trpcApi.useUtils();
  const queryClient = useQueryClient();
  const notification = useNotification();
  const handleApiException = useApiExceptionHandler();

  return useMutation({
    mutationFn: async ({ investorId, firmId }: Api.SkipCoolOffRequest) => {
      const response = await api.post<ApiResponse<Api.SkipCoolOffResponse>>(
        '/investment-cool-off/skip',
        { investorId, firmId },
      );
      return response.data.data;
    },
    onSuccess: async ({ investorId }) => {
      notification.success('Investment cool-off period skipped successfully.');

      await queryClient.invalidateQueries({
        queryKey: ['investment-cool-off'],
      });

      utils.investor.getInvestor.invalidate({ investorId });
      utils.investor.listInvestors.invalidate();
    },
    onError: (error: Error) => {
      handleApiException(error);
    },
  });
}

export default useSkipInvestmentCoolOff;
